import React, { useEffect } from 'react';
import { MiniTroopersHero } from './mini-troopers/MiniTroopersHero';
import { MiniTroopersWhatTheyLearn } from './mini-troopers/MiniTroopersWhatTheyLearn';
import { MiniTroopersReviews } from './mini-troopers/MiniTroopersReviews';
import { MiniTroopersFAQHeader } from './mini-troopers/MiniTroopersFAQHeader';
import { MiniTroopersFAQQuestions } from './mini-troopers/MiniTroopersFAQQuestions';
import { MiniTroopersFinalCTA } from './mini-troopers/MiniTroopersFinalCTA';
export function MiniTroopers() {
  useEffect(() => {
    document.title = 'Mini Troopers (Ages 3-5) | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2567">
      <MiniTroopersHero data-id="element-2568" />
      <MiniTroopersWhatTheyLearn data-id="element-2569" />
      <MiniTroopersReviews data-id="element-2570" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-2571">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2572">
          <MiniTroopersFAQHeader data-id="element-2573" />
          <MiniTroopersFAQQuestions data-id="element-2574" />
        </div>
      </section>
      <MiniTroopersFinalCTA data-id="element-2575" />
    </div>;
}